var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:['icon-button is-icon', {'outlined': _vm.outlined}, _vm.size],attrs:{"type":"is-text","size":_vm.size,"loading":_vm.loading,"type":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('icon-default',{attrs:{"icon":_vm.icon,"size":_vm.size,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }